import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component"];
import React from 'react';
import ContainerImpl from './container-impl';
var Container = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$component = props.component,
    component = _props$component === void 0 ? 'div' : _props$component,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ContainerImpl, _extends({}, otherProps, {
    component: component,
    ref: ref
  }));
});
export default Container;